import { Icon, IconButton } from "@chakra-ui/react";
import { ReactElement, useState } from "react";
import { createPortal } from "react-dom";
import { MdFullscreen } from "react-icons/md";
import { ControlPosition, useControl } from "react-map-gl";

interface ResetViewstateControlProps {
  position?: ControlPosition;
  onClick: () => void;
}

export default function ResetViewstateControl(
  props: ResetViewstateControlProps
): ReactElement {
  const { position, onClick } = props;

  const [controlContainer, setControlContainer] =
    useState<HTMLDivElement | null>(null);

  useControl(
    () => ({
      onAdd: () => {
        const container =
          document.querySelector<HTMLDivElement>(
            "div.mapboxgl-ctrl-group.reset-viewstate"
          ) ?? document.createElement("div");
        container.className =
          "mapboxgl-ctrl mapboxgl-ctrl-group reset-viewstate";
        setControlContainer(container);
        return container;
      },
      onRemove: () => {
        controlContainer?.parentNode?.removeChild(controlContainer);
      },
    }),
    { position }
  );

  return (
    <>
      {controlContainer != null &&
        createPortal(
          <IconButton
            minW="unset"
            lineHeight="0"
            aria-label="Reset zoom and position"
            title="Reset zoom and position"
            icon={<Icon as={MdFullscreen} w="1.25rem" h="1.25rem" />}
            onClick={onClick}
          />,
          controlContainer
        )}
    </>
  );
}
